// extracted by mini-css-extract-plugin
module.exports = {"mainClass":"layout_mainClass__u6YT9"};